export default "__VITE_ASSET__Bn2K6xQn__"